import React from "react";
import "./IconButton.scss";
import { Button } from "reactstrap";
import plusicon from "../../assets/images/icons/add.svg";
import exporticon from "../../assets/images/icons/export.svg";

export default function IconButton({
  icon,
  iconType,
  title,
  className = "",
  iconOnly = false,
  ariaLabel,
  ...buttonProps
}) {
  const buttonLabel =
    ariaLabel || (typeof title === "string" ? title : undefined);
  const buttonTitle = typeof title === "string" ? title : undefined;
  const typeIcon =
    iconType === "add"
      ? plusicon
      : iconType === "download"
        ? exporticon
        : null;

  return (
    <Button
      className={`btn-with-icon${iconOnly ? " icon-only" : ""}${
        className ? ` ${className}` : ""
      }`}
      aria-label={buttonLabel}
      title={buttonTitle}
      {...buttonProps}
    >
      {icon ? <span className="btn-icon">{icon}</span> : null}
      {typeIcon ? <img src={typeIcon} alt="" aria-hidden="true" /> : ""}
      {!iconOnly && title ? (
        <span className="btn-with-icon-title">{title}</span>
      ) : null}
    </Button>
  );
}
